import './page404.css';

const NotFound = () => {
  return (
    <div className='background__404'>
      <div className='bg404__child'>
        <div className='bg404__grandchild'>
          <h1 className='h__one'>
            40<span className='rotate'>4</span>
          </h1>
          <div className='content__box__404'>
            <h3 className='h__three'>Ooops...Looks like you&apos;re lost</h3>
            <p>the resource you are looking for went abroad!</p>
            <a href='/' className='link_404'>
              Let&apos;s go Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
